import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { AlertCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reference = params.get("reference");
  return (
    <div><Navbar />
      <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel">
        <AlertCircle className="mx-auto text-amber-500" size={64} />
        <h1 className="font-display text-2xl font-bold text-[#03281B] mt-6">Payment Cancelled</h1>
        <p className="text-slate-600 mt-2">Your payment was not completed. Your details are saved{reference ? ` under reference ${reference}` : ""}. You can try again or choose bank transfer.</p>
        <div className="flex items-center justify-center gap-3 mt-8">
          <button onClick={() => navigate("/checkout")} className="rounded-full bg-[#008057] text-white px-6 py-2.5 font-bold">Return to Checkout</button>
          <button onClick={() => navigate("/")} className="rounded-full border-2 border-[#E2EBF0] text-slate-600 px-6 py-2.5 font-bold">Home</button>
        </div>
      </div>
    </div>
  );
}
